import React from "react";
import { Tooltip } from "antd";
import DataTable from "../DataTable";
import { useAuth } from "../../contexts/AuthContext";
import { formatPrice } from "../../utils";

const ProductTable = () => {
  const { user } = useAuth();

  const columns = [
    {
      title: "Marka",
      dataIndex: "brand",
      key: "brand",
      dataType: "enum",
      options: [
        // user?.brands?.includes("LG") && {
        //   label: "LG",
        //   value: "LG",
        // },
        user?.brands?.includes("Tefal") && {
          label: "Tefal",
          value: "TEFAL",
        },
        user?.brands?.includes("Karcher") && {
          label: "Karcher",
          value: "KARCHER",
        },
      ],
    },
    {
      title: "Stok Kodu",
      dataIndex: "code",
      key: "code",
      dataType: "string",
    },
    {
      title: "Ürün Kodu",
      render: (text, record) => <a>{record.name.split("-")[0]}</a>,
    },
    {
      title: "Ürün İsmi",
      dataIndex: "name",
      key: "name",
      dataType: "string",
      render: (text) => <a>{text.split("-")[1]}</a>,
    },

    {
      title: "Fiyat",
      dataIndex: "price",
      key: "price",
      dataType: "float",
      render: (text) => <a>{formatPrice(text)} ₺</a>,
    },
    {
      title: "Kampanya Fiyatı",
      dataIndex: "campaignPrice",
      key: "campaignPrice",
      dataType: "float",
      render: (text) =>
        text ? (
          <a className="text-green-600 font-semibold">{formatPrice(text)} ₺</a>
        ) : (
          <span className="text-slate-400">—</span>
        ),
    },
    {
      // campaignRemaining hesaplanmış bir alan olduğu için filtrelenemez
      title: "Kampanya Adedi",
      dataIndex: "campaignRemaining",
      key: "campaignRemaining",
      dataType: "none",
      render: (text, record) => {
        if (!record.campaignPrice) {
          return <span className="text-slate-400">—</span>;
        }

        if (
          record.campaignQuantity === null ||
          record.campaignQuantity === undefined
        ) {
          return <span>Sınırsız</span>;
        }

        return (
          <span
            className={
              record.campaignRemaining > 0
                ? "text-green-600 font-semibold"
                : "text-red-500 font-semibold"
            }
          >
            {record.campaignRemaining} / {record.campaignQuantity}
          </span>
        );
      },
    },
    {
      title: "Kampanya Detayı",
      key: "campaignDetail",
      dataType: "none",
      render: (text, record) => {
        const details = [
          record.campaignBarcode &&
            `Birlikte satılacak ürünler: ${record.campaignBarcode
              .split(";")
              .join(", ")}`,
          record.campaignGiftQuantity &&
            `Her ${record.campaignGiftQuantity} adette 1 adet hediye`,
          record.campaignBundleDiscount &&
            `Birlikte alımda %${record.campaignBundleDiscount} indirim`,
          record.campaignNote,
        ].filter(Boolean);

        if (details.length === 0) {
          return <span className="text-slate-400">—</span>;
        }

        return (
          <Tooltip
            title={
              <div className="flex flex-col space-y-1">
                {details.map((detail, index) => (
                  <span key={index}>{detail}</span>
                ))}
              </div>
            }
          >
            <span className="text-blue-500 underline decoration-dotted cursor-help">
              Detay ({details.length})
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Stok",
      dataIndex: "quantity",
      key: "quantity",
      dataType: "integer",
    },
  ];
  return <DataTable columns={columns} table="products" />;
};
export default ProductTable;
